// extracted by mini-css-extract-plugin
export default {"root":"PlasmicLast3MonthsDataButton_root__rv5u3","text":"PlasmicLast3MonthsDataButton_text__fRpWf"};